export const serverBaseUrl = 'https://app.inventic.tech/api/';
export const whitelabelHost = 'eshaala.inventic.tech';
